var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28416 7.26878C4.29568 7.15399 4.27996 7.03811 4.23825 6.93055C4.19655 6.82299 4.13005 6.72679 4.04416 6.64978L2.27416 4.51678V4.19678H7.77216L12.0222 13.5168L15.7582 4.19678H20.9992V4.51578L19.4842 5.96678C19.4208 6.01616 19.3717 6.08163 19.3422 6.15636C19.3126 6.2311 19.3037 6.31239 19.3162 6.39178V17.0578C19.3034 17.1372 19.3123 17.2185 19.3419 17.2933C19.3714 17.3681 19.4206 17.4335 19.4842 17.4828L20.9632 18.9338V19.2528H13.5272V18.9338L15.0562 17.4468C15.2082 17.2968 15.2082 17.2518 15.2082 17.0228V8.40078L10.9492 19.2178H10.3742L5.41616 8.40078V15.6498C5.37516 15.9548 5.47616 16.2618 5.69116 16.4828L7.68316 18.8998V19.2188H2.03516V18.8998L4.02716 16.4828C4.13195 16.3736 4.20977 16.2414 4.25439 16.0967C4.29901 15.9521 4.30921 15.799 4.28416 15.6498V7.26878Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic-medium.e002ba46b384eacccbaabb39bc6339d7.svg";
export { ForwardRef as ReactComponent };